import React, { lazy } from 'react';
// project imports
import Loadable from '../components/common/lodable/Loadable';
import MainLayout from '../layout/MainLayout';
import { Navigate } from 'react-router-dom';


const ExistingQuotes = Loadable(
  lazy(() => import('../pages/eTrack/existingQuotes/ExistingQuotes'))
);
const ExistingQuoteDetail = Loadable(
  lazy(() => import('../pages/eTrack/existingQuotes/quoteDetail/QuoteDetail'))
);
const QuoteApproval = Loadable(
  lazy(() => import('../pages/eTrack/quoteApproval/QuoteApproval'))
);
const QuoteApprovalDetail = Loadable(
  lazy(() => import('../pages/eTrack/quoteApproval/quoteDetail/QuoteDetail'))
);
const ETrack = Loadable(lazy(() => import('../pages/eTrack/ETrack')));
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const ETrackRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <Navigate to="/etrack" replace />,
    },
    {
      path: '/home',
      element: <Navigate to="/etrack" replace />,
    },
    {
      path: 'etrack',
      allowed: true,
      children: [
        {
          path: 'existing-quotes',
          element: <ExistingQuotes />,
          featureName:  'eTrack', // passing fetureName 'eTrack' but based on userType it will return eTrackInternal OR eTrackCustomer
        },
        {
          path: 'existing-quotes/:id',
          element: <ExistingQuoteDetail />,
          featureName: 'eTrack', // passing fetureName 'eTrack' but based on userType it will return eTrackInternal OR eTrackCustomer
        },
        {
          path: 'quote-approval',
          element: <QuoteApproval />,
          featureName: 'eTrack', // passing fetureName 'eTrack' but based on userType it will return eTrackInternal OR eTrackCustomer
        },
        {
          path: 'quote-approval/:id',
          element: <QuoteApprovalDetail />,
          featureName: 'eTrack', // passing fetureName 'eTrack' but based on userType it will return eTrackInternal OR eTrackCustomer
        },
        { 
          index: true, 
          path: '/etrack', 
          element: <ETrack />, 
          featureName: 'eTrack', // passing fetureName 'eTrack' but based on userType it will return eTrackInternal OR eTrackCustomer
        },
      ],
    },
  ],
};

export default ETrackRoutes;
